import FeatureFlagsContext from 'context/feature-flags-context'
import { get } from 'es-toolkit/compat'

import React, { useContext, type ReactNode } from 'react'
type FeatureFlagProps = {
  children?: ReactNode
  featureName: string
}

export default function FeatureFlag(props: FeatureFlagProps): ReactNode {
  const features = useContext(FeatureFlagsContext)
  // If the feature flag is not found, is is disabled by default
  const feature = get(features, props.featureName, { isEnabled: false })
  return <>{feature.isEnabled ? props.children : null}</>
}
